import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { useEffect } from "react";
import LandingPage from "./pages/LandingPage";
import IntakeForm from "./pages/IntakeForm";
import AdminDashboard from "./pages/AdminDashboard";
import AdminCreditRepair from "./pages/AdminCreditRepair";
import AdminFunding from "./pages/AdminFunding";
import AdminDeleted from "./pages/AdminDeleted";
import ClientPortal from "./pages/ClientPortal";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import CreditRepair from "./pages/CreditRepair";
import Funding from "./pages/Funding";
import Services from "./pages/Services";
import About from "./pages/About";
import Blog from "./pages/Blog";
import FAQ from "./pages/FAQ";


// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="App font-body">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/intake" element={<IntakeForm />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/credit-repair" element={<CreditRepair />} />
          <Route path="/funding" element={<Funding />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/portal" element={<ClientPortal />} />
          <Route path="/portal/reset-password" element={<ClientPortal />} />

          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/credit-repair" element={<AdminCreditRepair />} />
          <Route path="/admin/funding" element={<AdminFunding />} />
          <Route path="/admin/deleted" element={<AdminDeleted />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
